import {
  forwardRef,
  ForwardRefExoticComponent,
  PropsWithChildren,
  PropsWithoutRef,
  RefAttributes,
} from 'react';
import { Button } from '../../basic/button/button';

type FR<T, P> = ForwardRefExoticComponent<PropsWithoutRef<P> & RefAttributes<T>>;

type Props = PropsWithChildren & {
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  tid?: string;
};

export const send: FR<HTMLButtonElement, Props> = forwardRef((props, ref) => {
  const { children, onClick, disabled, loading = false, tid } = props;

  return (
    <Button
      ref={ref}
      variant="primary"
      type="submit"
      onClick={onClick}
      disabled={disabled}
      loading={loading}
      tid={tid}
    >
      {children ?? 'Enviar'}
    </Button>
  );
});
